import { render, staticRenderFns } from "./TrialForm.vue?vue&type=template&id=4fe52c10&scoped=true&"
import script from "./TrialForm.vue?vue&type=script&lang=js&"
export * from "./TrialForm.vue?vue&type=script&lang=js&"
import style0 from "./TrialForm.vue?vue&type=style&index=0&id=4fe52c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe52c10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCardActions,VCardText,VForm,VSelect})
